import React, { useState, useEffect } from 'react'
import { Table, Button, Input, Space, Modal, DatePicker } from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import axios from 'axios'

import { toast } from 'react-toastify'
import { passedInterviewListAPIURL, IMG_BASE_URL } from '../../../AllAPI/AdminAPI'
import * as XLSX from 'xlsx'

const InterviewPassedList = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)

  const [loading, setLoading] = useState(false)

  const [confirmChecked, setConfirmChecked] = useState(false)
  const [passLoading, setPassLoading] = useState(false)
  const [failLoading, setFailLoading] = useState(false)
  const [interviewStatus, setInterviewStatus] = useState('')
  const [failReason, setFailReason] = useState('')
  const [saveLoading, setSaveLoading] = useState(false)

  useEffect(() => {
    fetchPassedInterviewsList()
  }, [])

  const fetchPassedInterviewsList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`${passedInterviewListAPIURL}`)

      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        whats_no: item.wh_mobile || '-',
        document_approval_date : item.documents.document_approval_date || "-",
        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (
      (item.full_name ?? '').toLowerCase().includes(search) ||
      (item.whats_no ?? '').toString().includes(search) ||
      (item.tax_id ?? '').toLowerCase().includes(search)
    )
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: 'WhatsApp No', dataIndex: 'whats_no' },
    { title: 'Document Approve Date', dataIndex: 'document_approval_date' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              setSelectedRecord(record.full_data)
              setConfirmChecked(false)
              setViewModalOpen(true)
            }}
          />
        </Space>
      ),
    },
  ]

  // =======CSS==========
  const labelCss = {
    fontWeight: '600',
  }

  const titleText = {
    fontWeight: '600',
    fontSize: '16px',
    color: '#235784',
  }

  const exportToExcel = () => {
    const excelData = filteredData.map((item) => {
      const student = { ...item.full_data }

      // Flatten nested objects
      student.admin = student.admin?.username || ''
      student.documents = JSON.stringify(student.documents || {})

      return student
    })

    const worksheet = XLSX.utils.json_to_sheet(excelData)
    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Interview Passed')

    XLSX.writeFile(workbook, 'Interview_Passed_List.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Passed Interviews List</h2>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            className="shadow"
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* ======Modal======= */}

      <Modal
        title={null}
        open={viewModalOpen}
        onCancel={() => setViewModalOpen(false)}
        footer={null}
        width={1000}
      >
        {selectedRecord && (
          <div className="py-3 px-md-3">
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                color: '#235784',
              }}
            >
              Student Interview Details
            </h3>

            <div
              className="border rounded shadow p-3"
              style={{ backgroundColor: '#f2f7fd' }}
            >
              {/* PERSONAL */}
              <h6 style={titleText}>- Personal Information :</h6>

              <div
                className="rounded mb-3"
                style={{
                  border: '1px solid #d2d2d2',
                  padding: '10px',
                }}
              >

                   <div className="col-12 col-md-3">
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.documents.s_pic}`}
                      alt="Profile Picture"
                      className="rounded-circle img-fluid rounded border"
                      style={{
                        width: '160px',
                        height: '160px',
                        objectFit: 'contain',
                        display: 'block',
                        }}
                      />
                  </div>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Full Name:</span>
                    <br />
                    {selectedRecord.s_fname} {selectedRecord.s_mname}{' '}
                    {selectedRecord.s_lname}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Date of Birth:</span>
                    <br />
                    {selectedRecord.date_of_birth}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Blood Group:</span>
                    <br />
                    {selectedRecord.blood_grp}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Mobile:</span>
                    <br />
                    {selectedRecord.mobile}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>WhatsApp No:</span>
                    <br />
                    {selectedRecord.wh_mobile}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Email:</span>
                    <br />
                    {selectedRecord.email}
                  </div>

                  <div className="col-md-12 mb-3">
                    <span style={labelCss}>Address:</span>
                    <br />
                    {selectedRecord.address}, {selectedRecord.village}, PIN -{' '}
                    {selectedRecord.pin}
                  </div>
                </div>
              </div>

              {/* ACADEMIC */}
              <h6 style={titleText}>- Academic Information :</h6>

              <div
                className="rounded mb-3"
                style={{
                  border: '1px solid #d2d2d2',
                  padding: '10px',
                }}
              >
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Last Attended College</span>
                    <br />
                    {selectedRecord.last_attended_clg_name}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Highest Qualification</span>
                    <br />
                    {selectedRecord.highest_qualification}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Degree</span>
                    <br />
                    {selectedRecord.specific_degree}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Percentage</span>
                    <br />
                    {selectedRecord.aggre_percentage} %
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Course Name</span>
                    <br />
                    {selectedRecord.course_name}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Passing Month / Year</span>
                    <br />
                    {selectedRecord.month_year_of_passing}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Current College</span>
                    <br />
                    {selectedRecord.curr_yr_clg_name}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Total Duration</span>
                    <br />
                    {selectedRecord.total_course_duration}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Remaining Duration</span>
                    <br />
                    {selectedRecord.remaining_course_duration}
                  </div>
                </div>
              </div>

              {/* FAMILY */}
              <h6 style={titleText}>- Family Information :</h6>

              <div
                className="rounded mb-3"
                style={{
                  border: '1px solid #d2d2d2',
                  padding: '10px',
                }}
              >
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <span style={labelCss}>Father</span>
                    <br />
                    {selectedRecord.father_fname} {selectedRecord.father_mname}{' '}
                    {selectedRecord.father_lname}
                  </div>

                  <div className="col-md-3 mb-3">
                    <span style={labelCss}>Father Mobile</span>
                    <br />
                    {selectedRecord.father_mob}
                  </div>

                  <div className="col-md-3 mb-3">
                    <span style={labelCss}>Occupation</span>
                    <br />
                    {selectedRecord.father_occ}
                  </div>

                  <div className="col-md-6 mb-3">
                    <span style={labelCss}>Mother</span>
                    <br />
                    {selectedRecord.mother_fname} {selectedRecord.mother_mname}{' '}
                    {selectedRecord.mother_lname}
                  </div>

                  <div className="col-md-3 mb-3">
                    <span style={labelCss}>Mother Mobile</span>
                    <br />
                    {selectedRecord.mother_mob}
                  </div>

                  <div className="col-md-3 mb-3">
                    <span style={labelCss}>Occupation</span>
                    <br />
                    {selectedRecord.mother_occ}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Family Members</span>
                    <br />
                    {selectedRecord.total_family_mamber}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Emergency Contact</span>
                    <br />
                    {selectedRecord.emergency_contact}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Emergency Name</span>
                    <br />
                    {selectedRecord.emergency_name}
                  </div>
                </div>
              </div>

              {/* REFERENCE */}
              <h6 style={titleText}>- Reference Information :</h6>

              <div
                className="rounded mb-3"
                style={{
                  border: '1px solid #d2d2d2',
                  padding: '10px',
                }}
              >
                <div className="row">
                  <div className="col-md-4">
                    <span style={labelCss}>Chairman Name</span>
                    <br />
                    {selectedRecord.chairman_name}
                  </div>

                  <div className="col-md-4">
                    <span style={labelCss}>Chairman Mobile</span>
                    <br />
                    {selectedRecord.chairman_mob}
                  </div>

                  <div className="col-md-4">
                    <span style={labelCss}>Chairman Village</span>
                    <br />
                    {selectedRecord.chairman_village}
                  </div>

                  <div className="col-md-4 mt-3">
                    <span style={labelCss}>Reference Name</span>
                    <br />
                    {selectedRecord.reference_name}
                  </div>

                  <div className="col-md-4 mt-3">
                    <span style={labelCss}>Reference Mobile</span>
                    <br />
                    {selectedRecord.reference_mobile}
                  </div>

                  <div className="col-md-4 mt-3">
                    <span style={labelCss}>Relation</span>
                    <br />
                    {selectedRecord.reference_relation}
                  </div>
                </div>
              </div>

              {/* LOCAL GUARDIAN */}
              <h6 style={titleText}>- Local Guardian Information :</h6>

              <div
                className="rounded mb-3"
                style={{
                  border: '1px solid #d2d2d2',
                  padding: '10px',
                }}
              >
                <div className="row">
                  <div className="col-md-4">
                    <span style={labelCss}>Name</span>
                    <br />
                    {selectedRecord.local_guardian_name}
                  </div>

                  <div className="col-md-4">
                    <span style={labelCss}>Mobile</span>
                    <br />
                    {selectedRecord.local_guardian_mobile}
                  </div>

                  <div className="col-md-4">
                    <span style={labelCss}>Address</span>
                    <br />
                    {selectedRecord.local_guardian_address}
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-4 p-3 border rounded bg-light">
              <div className="d-flex gap-2 justify-content-end mt-3">
                {/* <Button
                  onClick={() => {
                    setViewModalOpen(false)
                    setInterviewStatus('')
                    setFailReason('')
                  }}
                >
                  Cancel
                </Button> */}

                <Button
                  type="primary"
                  loading={saveLoading}
                  onClick={() => {
                    setViewModalOpen(false)
                  }}
                >
                  Ok
                </Button>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  )
}

export default InterviewPassedList
